__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "category-page";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@core-ui/app-state-provider", "3.1.0", function() { return Promise.all([__webpack_require__.e(4486), __webpack_require__.e(5325), __webpack_require__.e(1612)]).then(function() { return function() { return __webpack_require__(91612); }; }); });
			register("@core-ui/breakpoint-provider", "9.0.6", function() { return Promise.all([__webpack_require__.e(4486), __webpack_require__.e(5325), __webpack_require__.e(4576)]).then(function() { return function() { return __webpack_require__(19108); }; }); });
			register("@core-ui/certona-provider", "4.0.9", function() { return Promise.all([__webpack_require__.e(4486), __webpack_require__.e(7401), __webpack_require__.e(5325), __webpack_require__.e(3501)]).then(function() { return function() { return __webpack_require__(3501); }; }); });
			register("@core-ui/error-boundary", "2.0.34", function() { return __webpack_require__.e(6145).then(function() { return function() { return __webpack_require__(46145); }; }); });
			register("@core-ui/feature-flags", "2.0.2", function() { return Promise.all([__webpack_require__.e(5325), __webpack_require__.e(1261)]).then(function() { return function() { return __webpack_require__(18106); }; }); });
			register("@core-ui/localization-provider", "5.0.6", function() { return Promise.all([__webpack_require__.e(4486), __webpack_require__.e(7361), __webpack_require__.e(5325), __webpack_require__.e(2894)]).then(function() { return function() { return __webpack_require__(42894); }; }); });
			register("@core-ui/personalization-provider", "9.8.2", function() { return Promise.all([__webpack_require__.e(4486), __webpack_require__.e(4440), __webpack_require__.e(937), __webpack_require__.e(5325), __webpack_require__.e(6792)]).then(function() { return function() { return __webpack_require__(14440); }; }); });
			register("@emotion/react", "11.5.0", function() { return Promise.all([__webpack_require__.e(6024), __webpack_require__.e(733)]).then(function() { return function() { return __webpack_require__(30733); }; }); });
			register("react-universal-component", "4.5.0", function() { return Promise.all([__webpack_require__.e(6325), __webpack_require__.e(9177)]).then(function() { return function() { return __webpack_require__(36325); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};